/**
 * @Injectable
 * Service that guards all the routes
 *
 */

import { Injectable } from '@angular/core';
import { CanActivate, Router, NavigationExtras, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { CookieService } from 'angular2-cookie/core';

import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

  // Set our navigation extras object
  // that passes on our global query params and fragment
  navigationExtras: NavigationExtras = {
    preserveQueryParams: true,
    preserveFragment: true
  };

  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService
  ) {}


  /**
   * Function triggered by the angular router to check authentication
   *
   * @param		  {Object}      ActivatedRouteSnapshot
   * @param		  {Object}      RouterStateSnapshot
   * @return		{Boolean}     whether the route can by displayed or not
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Store current url
    let url: string = state.url;
    // Check if user logged
    let check = this.checkLogin(url);
    // Return if logged
    return check;
  }

  /**
   * Checks if user is logged
   *
   * @param		  {Object}      ActivatedRouteSnapshot
   * @param		  {Object}      RouterStateSnapshot
   * @return		{Boolean}     whether a user is logged or not
   */
  checkLogin(url: string): boolean {
    // Get current token
    let token = this.authService.tokenGet(url);
    // If token not set > return false
    if (!token) {
      // Navigate to the login page
      this.router.navigate(['/login'], this.navigationExtras);
      console.log(url);
      return false;
    }
    // Otherwise > return true
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts